import { render, staticRenderFns } from "./PCR_EachID.vue?vue&type=template&id=5773b891&scoped=true"
import script from "./PCR_EachID.vue?vue&type=script&lang=js"
export * from "./PCR_EachID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5773b891",
  null
  
)

export default component.exports